import LiveEffect from './LiveEffect.js';
import {
    FORWARD,
    REVERSE,
    FORWARD_REVERSE,
    BROWNIAN
} from 'constants/playhead-directions.js';
import {PLAYHEAD_EFFECT} from './constants.js';
import OptionParameter from 'parameters/OptionParameter.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';

class PlayheadEffect extends LiveEffect {
    constructor(track) {
        super('Playhead', PLAYHEAD_EFFECT, track);

        this.system5Objects = [];

        // long it actually sounds
        this.directionParameter = new OptionParameter(
            'direction', this, (o, x) => x,
            {
                min: 0,
                max: 1,
                isNumber: true,
                unit: '', 
                options: {
                    0.1: FORWARD,
                    0.25: REVERSE,
                    0.5: FORWARD_REVERSE,
                    0.75: BROWNIAN,
                },
                defaultValue: FORWARD
            }
        );

        this.registerParameter(this.directionParameter);

        // long it actually sounds
        this.speedFactorParameter = new AbstractParameter(
            'speedFactor', this, (o, x) => x,
            {
                min: 0,
                max: 16,
                unit: 'x', 
                defaultValue: 1,
                onChange: x => this.system5Objects.forEach(
                    s => s.sendSpeeds())
            }
        );

        this.registerParameter(this.speedFactorParameter);

        // offset in steps
        this.offsetParameter = new AbstractParameter(
            'offset', this, (o, x) => x,
            {
                min: 0,
                max: 32,
                unit: 'x', 
                defaultValue: 0
            }
        );

        this.registerParameter(this.offsetParameter);

        // long it actually sounds
        this.walkParameter = new AbstractParameter(
            'walk', this, (o, x) => x,
            {
                min: 1,
                max: 16,
                defaultValue: 8
            }
        );

        this.registerParameter(this.walkParameter);
    }

    getParameters() {
        return this.parameters;
    }

    get offset() {
        return this.offsetParameter.get();
    }

    get direction() {
        return this.directionParameter.get();
    }
    
    get speedFactor() {
        return this.speedFactorParameter.get();
    }

    get walk() {
        return Math.round(this.walkParameter.get());
    }

    fromJson(json, isCopy) {
        return super.fromJson(json, isCopy);
    }

    getCopy(track) {
        let copied = new PlayheadEffect(track);
        copied.fromJson(this.getJson());
        return copied;
    }
}

export default PlayheadEffect;
